import { StyleSheet } from 'react-native';

const QAAnswer4Image = ({ style }) => {
  const oneX = require('./QuiteaBit.jpg');
  const twoX = require('./QuiteaBit@2x.jpg');
  return (
    <img
      src={twoX}
      alt=""
      style={{ ...StyleSheet.flatten(style), objectFit: 'contain' }}
      srcSet={`${oneX}, ${twoX} 2x`}
    />
  );
};

export { QAAnswer4Image };
